import * as _ from 'lodash';
import * as React from 'react';
import { WrappedFieldInputProps } from 'redux-form';

import LargeIconButton, { LargeIconButtonConfig } from '../Buttons/LargeIconButton';

interface LargeIconButtonGroupProps {
  name: string;
  input: WrappedFieldInputProps;
  configs: LargeIconButtonConfig[];
  onSelect(value?: string): void;
}

export default class LargeIconButtonGroup extends React.Component<LargeIconButtonGroupProps> {
  render() {
    const { input, configs, onSelect } = this.props;

    return (
      <div>
        {_.map(configs, c => {
          return (
            <LargeIconButton
              key={c.value}
              buttonId={c.buttonId}
              iconComponent={c.iconComponent}
              text={c.text}
              subText={c.subText}
              onClick={() => {
                input.onChange(c.value);
                onSelect(c.value);
              }}
              selected={input.value === c.value}
            />
          );
        })}
      </div>
    );
  }
}
